import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from "../firebase_config";
import { signOut } from 'firebase/auth';

export default function FormDialog({ setCompanyModal }) {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  // Just closes the modal
  const close = () => {
    setOpen(false);
    setCompanyModal(false);
  };

  const Logout = async () => {
    try {
      signOut(auth);
      navigate("/");
    } catch (error) {
    }
  };

  return (
    <ScopedCssBaseline>
      <div>
        <Dialog open={open} onClose={close}>
          <DialogTitle style={{ backgroundColor: "white", color: "black" }}>
            Företagsval görs vid registrering
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "white", color: "black" }}>
            <Typography>
              Din registrering är mottagen och vi inväntar godkännande från administratör för att koppla ditt konto till ett företag.
            </Typography>
          </DialogContent>
          <DialogActions style={{ backgroundColor: "white" }}>
            <Button onClick={Logout}>Log Out</Button>
          </DialogActions>
        </Dialog>
      </div>
    </ScopedCssBaseline>
  );
}
